import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { handleLeft } from '../../../Actions/AllAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faShoppingCart, faTruck, faPercentage, faBoxes, faCalendarAlt, faChartBar, faUtensils,
    faAngleDown, faAngleRight, faBuilding, faUserFriends, faBell, faFileImport, faCog,
    faBars, faTachometerAlt, faSignOutAlt, faLayerGroup, faHouse, faFileInvoice
} from '@fortawesome/free-solid-svg-icons';
import Utility from '../Utility';
import { setToken, logOutApp, setUserCredentials, setUserEntryType } from '../../Login/Actions/LoginAction';
import IsEligibleToShow from './IsEligibleToShow';
const channel = new BroadcastChannel('foobar');

const Sidebar = ({ leftbar = false, handleLeft, userCredentials, currentStore, ...props }) => {
    // console.log("currentStore========", currentStore)
    const location = useLocation();
    const [collapsed, setCollapsed] = useState(leftbar);
    const [hidden, setHidden] = useState(false);
    const [expandedMenus, setExpandedMenus] = useState({});
    const [isLogout, setIsLogout] = useState(false);

    const hasPermission = (userType, roleKey, index, eventKey, allowedRules) => {
        if (userType === 'admin') return true;
        const role = Utility.getRoleObjectByEventKey(roleKey);
        // console.log("role=========", role);
        if (!role || !role.subeventKey || role.subeventKey.length <= index) return false;
        const sub = role.subeventKey[index];
        // console.log("sub=========", sub);
        // console.log(`Checking permission for eventKey: ${eventKey}, userType: ${userType}, allowedRules: ${allowedRules}`);
        return sub.eventKey === eventKey && allowedRules.includes(sub.rules);
    };

    const hasParentMenuPermission = (roleKey) => {
        if (userType === 'admin') return true;
        const role = Utility.getRoleObjectByEventKey(roleKey);
        if (!role) return false;
        // Check if parent menu has valid rules (not empty string)
        return role.rules && role.rules.trim() !== '';
    };

    const hasOrderCreationAbility = () => {
        return (currentStore?.store_type === 'BRANCH' && !currentStore?.is_procurement_hub) || (currentStore?.store_type === 'COST_CENTER' && currentStore?.can_sell);
    };

    const shouldHideMenuForCentralHub = Utility.chkOrgStoreCentralHub(currentStore, currentStore?.orgMetaStoreRelation);

    const hasProcurement = () => {
        return currentStore?.store_type === 'COST_CENTER' || (currentStore?.is_procurement_hub);
    };

    const checkEligibilityToShow = (eventKey) => {
        let storeDetails = currentStore ? { "store_type": currentStore.store_type, "is_procurement_hub": currentStore.is_procurement_hub, "can_sell": currentStore.can_sell } : { "store_type": null, "is_procurement_hub": false, "can_sell": false };
        const orgDetails = { "allow_main_store": currentStore?.orgMetaStoreRelation?.allow_main_store };
        let IsEligibleToShowTab = IsEligibleToShow(eventKey, storeDetails, orgDetails);
        // console.log(`Eligibility for ${eventKey}:`, IsEligibleToShowTab);
        return IsEligibleToShowTab;
    };

    const userType = userCredentials.user_details?.user_type;
    const isSubscribed = userCredentials.user_details?.is_subscribed;
    // console.log("has permission=========", (hasPermission(userType, 'dashboard', 1, 'master_dashboard', ['CRUD', 'CUD', 'R'])));
    // Navigation items configuration
    // console.log("role_permission====>",userCredentials.user_details?.role_permission);
    const navItems = [
        ...(userCredentials.user_details?.user_type === "app_admin"
            ? [{
                icon: faHouse,
                text: 'Home',
                path: '/home',
                submenu: [
                    { text: 'Organizations', path: '/home/organisation' },
                    { text: 'Admin', path: '/home/admin' },
                    { text: 'Support User', path: '/home/support_user' }
                ]
            }
            ]
            : []
        ),
        ...(['admin'].includes(userCredentials.user_details?.user_type) && checkEligibilityToShow('dashboard') && isSubscribed || (Object.keys(Utility.getRoleObjectByEventKey('dashboard')).length > 0) && isSubscribed && checkEligibilityToShow('dashboard') && hasParentMenuPermission('dashboard')
            ? [{
                icon: faTachometerAlt,
                text: 'Dashboard',
                path: '/dashboard',
                submenu: [
                    ...(checkEligibilityToShow('master_dashboard') && hasPermission(userType, 'dashboard', 0, 'master_dashboard', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Master Dashboard', path: '/dashboard' }]
                        : []),
                    // ...(hasPermission(userType, 'dashboard', 0, 'master_dashboard', ['CRUD', 'CUD', 'R'])
                    //     ? [{ text: 'Master Dashboard Legacy', path: '/dashboard' }]
                    //     : []),

                    ...(checkEligibilityToShow('billing_counter_dashboard') && hasPermission(userType, 'dashboard', 1, 'billing_counter_dashboard', ['CRUD', 'CUD', 'R'])
                        // && !Utility.isMainOrProcurementHubStore(currentStore)
                        ? [{ text: 'Billing Counter Dashboard', path: '/dashboard/billing-counter' }]
                        : []),
                ],
            },
            ]
            : []),

        ...(['admin'].includes(userCredentials.user_details?.user_type) && checkEligibilityToShow('sales_and_orders') && isSubscribed || (Object.keys(Utility.getRoleObjectByEventKey('sales_and_orders')).length > 0) && isSubscribed && checkEligibilityToShow('sales_and_orders') && hasParentMenuPermission('sales_and_orders')
            ? [{
                icon: faShoppingCart,
                text: 'Sales & Orders',
                path: '/sales',
                submenu: [
                    ...(checkEligibilityToShow('purchase_orders') && hasPermission(userType, 'sales_and_orders', 0, 'purchase_orders', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Purchase Orders', path: '/sales/purchase-orders' }]
                        : []),

                    ...(checkEligibilityToShow('invoices') && hasPermission(userType, 'sales_and_orders', 1, 'invoices', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Invoices', path: '/sales/invoices' }]
                        : []),

                    ...(checkEligibilityToShow('orders') && hasPermission(userType, 'sales_and_orders', 2, 'orders', ['CRUD', 'CUD', 'R'])
                        // && hasOrderCreationAbility()
                        ? [{ text: 'Orders', path: '/sales/orders' }]
                        : []),

                    ...(checkEligibilityToShow('digital_menu_orders') && hasPermission(userType, 'sales_and_orders', 3, 'digital_menu_orders', ['CRUD', 'CUD', 'R']) && hasOrderCreationAbility()
                        ? [{ text: 'Digital Menu Orders', path: '/sales/digital-menu-orders' }]
                        : []),

                    ...(checkEligibilityToShow('quotations') && hasPermission(userType, 'sales_and_orders', 4, 'quotations', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Quotations', path: '/sales/quotations' }]
                        : []),

                    ...(checkEligibilityToShow('transactions') && hasPermission(userType, 'sales_and_orders', 5, 'transactions', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Transactions', path: '/sales/transactions' }]
                        : []),

                    ...(checkEligibilityToShow('requisitions') && hasPermission(userType, 'sales_and_orders', 6, 'requisitions', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Requisitions', path: '/sales/requisitions' }]
                        : []),

                    ...(checkEligibilityToShow('grn') && hasPermission(userType, 'sales_and_orders', 7, 'grn', ['CRUD', 'CUD', 'R']) ? [{ text: 'GRN', path: '/sales/grn' }]
                        : []),
                ],
            }]
            : []
        ),

        // ...(['admin'].includes(userCredentials.user_details?.user_type) && isSubscribed || (Object.keys(Utility.getRoleObjectByEventKey('sales_and_orders')).length > 0) && isSubscribed
        //     ? [{
        //         icon: faShoppingCart,
        //         text: 'Procurement',
        //         path: '/procurement',
        //         submenu: [
        //             ...(hasPermission(userType, 'sales_and_orders', 6, 'requisitions', ['CRUD', 'CUD', 'R'])
        //                 ? [{ text: 'Requisitions', path: '/sales/requisitions' }]
        //                 : []),

        //             ...(hasPermission(userType, 'sales_and_orders', 7, 'grn', ['CRUD', 'CUD', 'R']) ? [{ text: 'GRN', path: '/sales/grn' }]
        //                 : []),
        //         ],
        //     }]
        //     : []
        // ),

        ...(['admin'].includes(userCredentials.user_details?.user_type) && checkEligibilityToShow('business_account') && isSubscribed || (Object.keys(Utility.getRoleObjectByEventKey('business_account')).length > 0) && isSubscribed && checkEligibilityToShow('business_account') && hasParentMenuPermission('business_account')
            ? [{
                icon: faBuilding,
                text: 'Business Account',
                path: '/business',
                submenu: [
                    ...(checkEligibilityToShow('accounts') && hasPermission(userType, 'business_account', 0, 'accounts', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Accounts', path: '/business/accounts' }]
                        : []),

                    ...(checkEligibilityToShow('monthly_targets') && hasPermission(userType, 'business_account', 1, 'monthly_targets', ['CRUD', 'CUD', 'R'])
                        //  && !Utility.isMainOrProcurementHubStore(currentStore)
                        ? [{ text: 'Monthly Targets', path: '/business/monthly-targets' }]
                        : []),

                    ...(checkEligibilityToShow('business_registers') && hasPermission(userType, 'business_account', 2, 'business_registers', ['CRUD', 'CUD', 'R'])
                        // && !Utility.isMainOrProcurementHubStore(currentStore)
                        ? [{ text: 'Business Registers', path: '/business/registers' }]
                        : []),
                ],
            }]
            : []
        ),
        ...(['admin'].includes(userCredentials.user_details?.user_type) && checkEligibilityToShow('user_and_customer') && isSubscribed || (Object.keys(Utility.getRoleObjectByEventKey('user_and_customer')).length > 0) && isSubscribed && checkEligibilityToShow('user_and_customer') && hasParentMenuPermission('user_and_customer')
            ? [{
                icon: faUserFriends,
                text: 'User & Customer',
                path: '/users',
                submenu: [
                    ...(checkEligibilityToShow('users') && hasPermission(userType, 'user_and_customer', 0, 'users', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Users', path: '/user/user' }]
                        : []),

                    ...(checkEligibilityToShow('customers') && hasPermission(userType, 'user_and_customer', 1, 'customers', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Customers', path: '/user/customer' }]
                        : []),

                    ...(checkEligibilityToShow('roles') && hasPermission(userType, 'user_and_customer', 2, 'roles', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Roles', path: '/user/role' }]
                        : []),
                ],
            },
            ]
            : []
        ),
        ...(['admin'].includes(userCredentials.user_details?.user_type) && checkEligibilityToShow('supplier') && isSubscribed && hasProcurement() || (Object.keys(Utility.getRoleObjectByEventKey('supplier')).length > 0) && isSubscribed && checkEligibilityToShow('supplier') && hasParentMenuPermission('supplier')
            // hasProcurement()
            ? [{
                icon: faTruck,
                text: 'Supplier',
                path: '/supplier',
                submenu: [
                    ...(checkEligibilityToShow('suppliers') && hasPermission(userType, 'supplier', 0, 'suppliers', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Suppliers', path: '/supplier' }]
                        : []),
                ]
            }
            ]
            : []
        ),
        ...(['admin'].includes(userCredentials.user_details?.user_type) && checkEligibilityToShow('tax_and_discount_codes') && isSubscribed || (Object.keys(Utility.getRoleObjectByEventKey('tax_and_discount_codes')).length > 0) && isSubscribed && checkEligibilityToShow('tax_and_discount_codes') && hasParentMenuPermission('tax_and_discount_codes')
            ? [{
                icon: faPercentage,
                text: 'Tax & Discount Codes',
                path: '/tax-discount',
                submenu: [
                    ...(checkEligibilityToShow('tax_codes') && hasPermission(userType, 'tax_and_discount_codes', 0, 'tax_codes', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Tax Codes', path: '/tax-codes' }]
                        : []),
                    ...(checkEligibilityToShow('discount_codes') && hasPermission(userType, 'tax_and_discount_codes', 1, 'discount_codes', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Discount Codes', path: '/discount-codes' }]
                        : []),
                ]
            }]
            : []
        ),
        ...(['admin'].includes(userCredentials.user_details?.user_type) && checkEligibilityToShow('stock') && isSubscribed || (Object.keys(Utility.getRoleObjectByEventKey('stock')).length > 0) && isSubscribed && checkEligibilityToShow('stock') && hasParentMenuPermission('stock')
            ? [{
                icon: faBoxes,
                text: 'Stock',
                path: '/stock',
                submenu: [
                    ...(checkEligibilityToShow('products') && hasPermission(userType, 'stock', 0, 'products', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Products', path: '/stock/products' }]
                        : []),
                    ...(checkEligibilityToShow('categories') && hasPermission(userType, 'stock', 1, 'categories', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Categories', path: '/category' }]
                        : []),
                    ...(checkEligibilityToShow('stock_transfer') && hasPermission(userType, 'stock', 3, 'stock_transfer', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Stock Transfer', path: '/stock/transfer' }]
                        : []),
                    ...(checkEligibilityToShow('stock_return') && hasPermission(userType, 'stock', 4, 'stock_return', ['CRUD', 'CUD', 'R'])
                        // && currentStore?.store_type !== 'COST_CENTER'
                        ? [{ text: 'Stock Return', path: '/stock/return' }]
                        : []),
                    ...(checkEligibilityToShow('product_label') && hasPermission(userType, 'stock', 2, 'product_label', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Product Label', path: '/stock/products-label' }]
                        : []),
                    ...(checkEligibilityToShow('add_on_groups') && hasPermission(userType, 'stock', 5, 'add_on_groups', ['CRUD', 'CUD', 'R'])
                        // && !shouldHideMenuForCentralHub
                        ? [{ text: 'Add-on Groups', path: '/stock/addon-groups' }]
                        : []),
                ]
            }]
            : []
        ),
        ...((['admin'].includes(userCredentials.user_details?.user_type) && isSubscribed && checkEligibilityToShow('bookings_and_calendar') || (Object.keys(Utility.getRoleObjectByEventKey('bookings_and_calendar')).length > 0) && isSubscribed && checkEligibilityToShow('bookings_and_calendar') && hasParentMenuPermission('bookings_and_calendar')) && !Utility.isNotRestaurantStore(currentStore)
            ? [{
                icon: faCalendarAlt,
                text: 'Bookings & Calendar',
                path: '/booking-events',
                submenu: [
                    ...(checkEligibilityToShow('bookings_events') && hasPermission(userType, 'bookings_and_calendar', 0, 'bookings_events', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Bookings & Events', path: '/booking-events' }]
                        : []),
                    ...(checkEligibilityToShow('calendar') && hasPermission(userType, 'bookings_and_calendar', 1, 'calendar', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Calendar', path: '/calendar' }]
                        : []),
                ]
            }]
            // {
            //   icon: faCalendarAlt,
            //   text: 'Booking & Events',
            //   path: '/booking-events',
            //   submenu: [{ text: 'Booking & Events', path: '/booking-events' }]
            // }
            : []
        ),
        ...(['admin'].includes(userCredentials.user_details?.user_type) && isSubscribed && checkEligibilityToShow('reports') || (Object.keys(Utility.getRoleObjectByEventKey('reports')).length > 0) && isSubscribed && checkEligibilityToShow('reports') && hasParentMenuPermission('reports')
            ? [{
                icon: faChartBar,
                text: 'Reports',
                path: '/reports',
                submenu: [
                    ...(checkEligibilityToShow('download_reports') && hasPermission(userType, 'reports', 0, 'download_reports', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Download Reports', path: '/reports/download' }]
                        : []),
                    ...(checkEligibilityToShow('best_seller_report') && hasPermission(userType, 'reports', 1, 'best_seller_report', ['CRUD', 'CUD', 'R'])
                        //  && !Utility.isMainOrProcurementHubStore(currentStore)
                        ? [{ text: 'Best Seller Report', path: '/reports/best-seller' }]
                        : []),
                    ...(checkEligibilityToShow('day_wise_sale_report') && hasPermission(userType, 'reports', 2, 'day_wise_sale_report', ['CRUD', 'CUD', 'R'])
                        // && !Utility.isMainOrProcurementHubStore(currentStore)
                        ? [{ text: 'Day Wise Sale Report', path: '/reports/day-wise-sale' }]
                        : []),
                    ...(checkEligibilityToShow('category_report') && hasPermission(userType, 'reports', 3, 'category_report', ['CRUD', 'CUD', 'R'])
                        // && !Utility.isMainOrProcurementHubStore(currentStore)
                        ? [{ text: 'Category Report', path: '/reports/category' }]
                        : []),
                    ...(checkEligibilityToShow('stock_quantity_alert') && hasPermission(userType, 'reports', 4, 'stock_quantity_alert', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Stock Quantity Alert', path: '/reports/stock-alert' }]
                        : []),
                    ...(checkEligibilityToShow('store_stock_chart') && hasPermission(userType, 'reports', 5, 'store_stock_chart', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Store Stock Chart', path: '/reports/store-stock-chart' }]
                        : []),
                    ...(checkEligibilityToShow('product_audit_history') && hasPermission(userType, 'reports', 6, 'product_audit_history', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Product Audit History', path: '/reports/product-audit-history' }]
                        : []),
                    ...(checkEligibilityToShow('product_audit_trail') && hasPermission(userType, 'reports', 7, 'product_audit_trail', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Product Audit Trail', path: '/reports/product-audit-trail' }]
                        : []),
                    ...(checkEligibilityToShow('change_in_transaction') && hasPermission(userType, 'reports', 8, 'change_in_transaction', ['CRUD', 'CUD', 'R']) ? [{ text: 'Transaction Audit History', path: '/reports/change-in-transaction' }]
                        : []),

                    ...(checkEligibilityToShow('night_audit_report') && hasPermission(userType, 'reports', 9, 'night_audit_report', ['CRUD', 'CUD', 'R'])
                        // &&  !Utility.isMainOrProcurementHubStore(currentStore)
                        ? [{ text: 'Night Audit Report', path: '/reports/night-audit-report' }]
                        : []),
                    ...(checkEligibilityToShow('login_activities') && hasPermission(userType, 'reports', 10, 'login_activities', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Login Activities', path: '/reports/login-activities' }]
                        : []),
                    ...(checkEligibilityToShow('pms_sync_report') && hasPermission(userType, 'reports', 11, 'pms_sync_report', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'PMS Sync Report', path: '/reports/pms-sync-report' }]
                        : []),
                    ...(checkEligibilityToShow('supplier_ledger') && hasPermission(userType, 'reports', 12, 'supplier_ledger', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Supplier Ledger', path: '/reports/supplier-ledger' }]
                        : []),
                ]
            }]
            : []
        ),
        ...(['admin'].includes(userCredentials.user_details?.user_type) && isSubscribed &&
            !Utility.isNotRestaurantStore(currentStore) && checkEligibilityToShow('restaurant')
            //  && hasOrderCreationAbility() 
            || (Object.keys(Utility.getRoleObjectByEventKey('restaurant')).length > 0) && isSubscribed && !Utility.isNotRestaurantStore(currentStore) && checkEligibilityToShow('restaurant') && hasParentMenuPermission('restaurant')
            //  && hasOrderCreationAbility()
            ? [{
                icon: faUtensils,
                text: 'Restaurant',
                path: '/restaurant',
                submenu: [
                    ...(checkEligibilityToShow('kitchen_display') && hasPermission(userType, 'restaurant', 0, 'kitchen_display', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Kitchen Display', path: '/restaurant/kitchen-display' }]
                        : []),
                    ...(checkEligibilityToShow('waiter_display') && hasPermission(userType, 'restaurant', 2, 'waiter_display', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Waiter Display', path: '/restaurant/waiter-display' }]
                        : []),
                    ...(checkEligibilityToShow('tables') && hasPermission(userType, 'restaurant', 1, 'tables', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Tables', path: '/restaurant/tables' }]
                        : []),
                    ...(checkEligibilityToShow('restaurant_menu')
                        // && currentStore?.digital_menu_enabled 
                        && hasPermission(userType, 'restaurant', 3, 'restaurant_menu', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Restaurant Menu', path: '/restaurant/menu' }]
                        : []),
                ]
            }]
            : []
        ),
        ...(['admin'].includes(userCredentials.user_details?.user_type) && isSubscribed && checkEligibilityToShow('notification') || (Object.keys(Utility.getRoleObjectByEventKey('notification')).length > 0) && isSubscribed && checkEligibilityToShow('notification') && hasParentMenuPermission('notification')
            ? [{
                icon: faBell,
                text: 'Notification',
                path: '/notification',
                submenu: [
                    ...(checkEligibilityToShow('notifications') && hasPermission(userType, 'notification', 0, 'notifications', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Notifications', path: '/notification/list' }]
                        : []),
                ]
            }]
            : []
        ),
        // ...(['admin'].includes(props.userCredentials.user_details?.user_type) && isSubscribed || (Object.keys(Utility.getRoleObjectByEventKey('import_data')).length > 0) && isSubscribed
        //     ? [{
        //         icon: faFileImport,
        //         text: 'Import Data',
        //         path: '/import',
        //         submenu: [
        //             ...(hasPermission(userType, 'import_data', 0, 'import_data', ['CRUD', 'CUD', 'R'])
        //                 ? [{ text: 'Import Data', path: '/import/data' }]
        //                 : []),
        //             ...(hasPermission(userType, 'import_data', 0, 'import_data', ['CRUD', 'CUD', 'R'])
        //                 ? [{ text: 'Upload & Update Data', path: '/import/upload-update' }]
        //                 : []),
        //         ]
        //     }]
        //     : []
        // ),
        ...(['app_admin', 'admin'].includes(userCredentials.user_details?.user_type) && checkEligibilityToShow('settings') || (Object.keys(Utility.getRoleObjectByEventKey('settings')).length > 0) && checkEligibilityToShow('settings') && hasParentMenuPermission('settings')
            ? [{
                icon: faCog,
                text: 'Settings',
                path: '/settings',
                submenu: [
                    ...(checkEligibilityToShow('stores') && hasPermission(userType, 'settings', 0, 'stores', ['CRUD', 'CUD', 'R'])
                        ? [{ text: 'Stores', path: '/settings/stores' }
                        ] : []),
                    ...(checkEligibilityToShow('operating_hours') && hasPermission(userType, 'settings', 1, 'operating_hours', ['CRUD', 'CUD', 'R'])
                        // && hasOrderCreationAbility()
                        ? [{ text: 'Operating Hours', path: '/settings/stores/operating-hours' }
                        ] : []),
                    ...(checkEligibilityToShow('payment_methods') && hasPermission(userType, 'settings', 2, 'payment_methods', ['CRUD', 'CUD', 'R'])
                        && isSubscribed
                        // && !shouldHideMenuForCentralHub
                        ? [{ text: 'Payment Methods', path: '/settings/payment-methods' }
                        ] : []),
                    ...(checkEligibilityToShow('billing_counters') && hasPermission(userType, 'settings', 3, 'billing_counters', ['CRUD', 'CUD', 'R'])
                        && isSubscribed
                        //  && hasOrderCreationAbility()
                        ? [{ text: 'Billing Counters', path: '/settings/billing-counters' }
                        ] : []),
                    ...(checkEligibilityToShow('coupons') && hasPermission(userType, 'settings', 8, 'coupons', ['CRUD', 'CUD', 'R']) && isSubscribed 
                        ? [{ text: 'Coupons', path: '/settings/coupons' }
                        ] : []),
                    // ...(hasPermission(userType, 'settings', 3, 'email_settings', ['CRUD', 'CUD', 'R']) && isSubscribed
                    //     ? [{ text: 'Email Settings', path: '/settings/email' }
                    //     ] : []),
                    // ...(hasPermission(userType, 'settings', 4, 'sms_settings', ['CRUD', 'CUD', 'R']) && isSubscribed
                    //     ? [{ text: 'SMS Settings', path: '/settings/sms' }
                    //     ] : []),
                    // ...(hasPermission(userType, 'settings', 5, 'sms_templates', ['CRUD', 'CUD', 'R']) && isSubscribed
                    //     ? [{ text: 'SMS Templates', path: '/settings/sms-templates' }
                    //     ] : []),
                    ...(checkEligibilityToShow('measurement_units') && hasPermission(userType, 'settings', 4, 'measurement_units', ['CRUD', 'CUD', 'R'])
                        && isSubscribed
                        ? [{ text: 'Measurement Units', path: '/settings/measurement-units' }
                        ] : []),
                    ...(checkEligibilityToShow('variant_options') && hasPermission(userType, 'settings', 5, 'variant_options', ['CRUD', 'CUD', 'R'])
                        && isSubscribed
                        // && !shouldHideMenuForCentralHub
                        ? [{ text: 'Variant Options', path: '/settings/variant-options' }
                        ] : []),
                    // ...(hasPermission(userType, 'settings', 8, 'printers', ['CRUD', 'CUD', 'R']) && isSubscribed
                    //     ? [{ text: 'Printers', path: '/settings/printers' }
                    //     ] : []),
                    ...(checkEligibilityToShow('kitchen_displays') && hasPermission(userType, 'settings', 6, 'kitchen_displays', ['CRUD', 'CUD', 'R'])
                        && isSubscribed
                        // && !Utility.isNotRestaurantStore(currentStore) && hasOrderCreationAbility()
                        ? [{ text: 'Kitchen Displays', path: '/settings/kitchen-displays' }
                        ] : []),

                    ...(checkEligibilityToShow('bill_posting_settings') && hasPermission(userType, 'settings', 7, 'bill_posting_settings', ['CRUD', 'CUD', 'R'])
                        && isSubscribed
                        ? [{ text: 'PMS Integration Settings', path: '/settings/bill-posting-settings' }
                        ] : []),

                    // ...(hasPermission(userType, 'settings', 10, 'app_settings', ['CRUD', 'CUD', 'R'])
                    //     ? [{ text: 'App Settings', path: '/settings/app_settings' }
                    //     ] : []),
                    ...(userCredentials.user_details?.user_type === "app_admin"
                        ? [{ text: 'Bank Details', path: '/settings/bank_details' }]
                        : []),
                    ...(userCredentials.user_details?.user_type === "app_admin"
                        ? [{ text: 'Subscription', path: '/settings/subscription' }]
                        : []),
                ]
            }]
            : []
        ),

        // ...(['admin'].includes(props.userCredentials.user_details?.user_type) && isSubscribed || (Object.keys(Utility.getRoleObjectByEventKey('business_account')).length > 0) && isSubscribed
        //         ? [{ 
        //           icon: faBuilding,
        //           text: 'Business Account',
        //           path: '/business',
        //           submenu: [
        //             ...(hasPermission(userType, 'business_account', 0, 'accounts', ['CRUD', 'CUD', 'R'])
        //                 ? [{ text: 'Accounts', path: '/business/accounts' }]
        //                 : []),

        //             ...(hasPermission(userType, 'business_account', 1, 'monthly_targets', ['CRUD', 'CUD', 'R'])
        //                 ? [{ text: 'Monthly Targets', path: '/business/monthly-targets' }]
        //                 : []),
        //           ],
        //         }]
        //         : []
        // ),
    ];

    // Initialize sidebar state and handle active menu/submenu
    useEffect(() => {
        try {
            const savedState = localStorage.getItem('sidebarState');
            if (savedState) {
                const { collapsed: savedCollapsed, hidden: savedHidden } = JSON.parse(savedState);
                setCollapsed(savedCollapsed);
                if (handleLeft) handleLeft(savedCollapsed);
                setHidden(savedHidden);
            } else {
                setCollapsed(leftbar || false);
            }

            // Add resize event listener
            window.addEventListener('resize', handleResize);
            handleResize();
        } catch (error) {
            console.error('Error initializing sidebar state:', error);
            setCollapsed(false);
            setHidden(false);
        }

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [leftbar, handleLeft]);

    // Keep local state in sync with Redux state
    useEffect(() => {
        setCollapsed(leftbar || false);
    }, [leftbar]);

    // Determine active menu based on current path - moved inside useEffect
    useEffect(() => {
        const currentPath = location.pathname;
        const newExpandedMenus = {};
        navItems.forEach(item => {
            const isActive = item.submenu?.some(subItem =>
                currentPath === `/${localStorage.getItem('i18nextLng') || 'en'}${subItem.path}` ||
                currentPath.startsWith(`/${localStorage.getItem('i18nextLng') || 'en'}${subItem.path}/`)
            );
            if (isActive) {
                newExpandedMenus[item.text] = true;
            }
        });
        setExpandedMenus(prev => ({ ...prev, ...newExpandedMenus }));
    }, [location.pathname]);

    // Handle responsive behavior
    const handleResize = () => {
        // if (window.innerWidth < 768) {
        //     setCollapsed(true);
        //     if (handleLeft) handleLeft(true);
        //    setHidden(false);
        // } else {
        //     setHidden(false);
        // }
        setHidden(false);
    };

    // Toggle sidebar collapsed state
    const toggleSidebar = () => {
        const newCollapsedState = !collapsed;
        setCollapsed(newCollapsedState);
        if (handleLeft) handleLeft(newCollapsedState);

        // Save state to localStorage
        try {
            localStorage.setItem('sidebarState', JSON.stringify({
                collapsed: newCollapsedState,
                hidden: false
            }));
        } catch (error) {
            console.error('Error saving sidebar state:', error);
        }
    };

    // Toggle submenu expansion
    const toggleSubmenu = (index) => {
        setExpandedMenus(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    // Prefix path with language
    const getLanguagePath = (path) => {
        const lang = localStorage.getItem('i18nextLng') || 'en';
        return `/${lang}${path}`;
    };

    const logout = () => {
        const { logOutApp, history, setToken, setUserCredentials } = props;
        logOutApp(accessToken, token).then((logoutResponce) => {
            setTimeout(() => {
                const isLogout = true;

                const clearCredentials = () => {
                    localStorage.setItem("selectedTabName", "");
                    setToken("", "", "", "", [], [], "").then(() => {
                        setUserCredentials({});
                    });
                };

                if (logoutResponce.success) {
                    clearCredentials();
                } else {
                    clearCredentials();
                }

                const obj = {
                    isLogout: isLogout,
                    allTabAction: "logoutAllTab"
                };

                channel.postMessage(obj);
            }, 1000);
        });
    }

    // console.log("role==========",Object.keys(Utility.getRoleObjectByEventKey('business_account')).length > 0 && (Utility.getRoleObjectByEventKey('business_account').subeventKey.length > 0 && Utility.getRoleObjectByEventKey('business_account').subeventKey[0].eventKey == "accounts" && (Utility.getRoleObjectByEventKey('business_account').subeventKey[0].rules == "CRUD" || Utility.getRoleObjectByEventKey('business_account').subeventKey[0].rules == "R")))

    return (
        <div className={`sidebar ${collapsed ? 'collapsed' : ''} ${hidden ? 'hidden' : ''}`}>
            <div className="sidebar-header">
                <div className="logo-container">
                    {!collapsed ? (
                        <h3 className="logo-text">Mettastay POS</h3>
                    ) : (
                        <h3 className="logo-text-small">MPOS</h3>
                    )}
                </div>
                <button className="sidebar-toggle" onClick={toggleSidebar}>
                    <FontAwesomeIcon icon={faBars} />
                </button>
            </div>

            <div className="sidebar-menu">
                <ul className="nav-list">
                    {navItems.map((item, index) => {
                        // Find exact match first to prioritize specific paths over general ones
                        const exactMatch = item.submenu?.find(subItem =>
                            location.pathname === getLanguagePath(subItem.path)
                        );

                        // If exact match exists, use it. Otherwise check prefix matches
                        const isActive = exactMatch ? true : (
                            item.submenu?.some(subItem =>
                                location.pathname.startsWith(getLanguagePath(subItem.path) + '/')
                            ) || location.pathname === getLanguagePath(item.path)
                        );

                        return (
                            <li key={index} className={`nav-item ${isActive ? 'active' : ''}`}>
                                {item.submenu ? (
                                    <>
                                        <div
                                            className={`nav-link has-submenu`}
                                            onClick={() => toggleSubmenu(item.text)}
                                        >
                                            <FontAwesomeIcon icon={item.icon} className="nav-icon" />
                                            {!collapsed && (
                                                <>
                                                    <span className="nav-text">{item.text}</span>
                                                    <FontAwesomeIcon
                                                        icon={expandedMenus[item.text] ? faAngleDown : faAngleRight}
                                                        className="submenu-icon"
                                                    />
                                                </>
                                            )}
                                        </div>
                                        {(!collapsed || (collapsed && expandedMenus[item.text])) && (
                                            <ul className={`submenu ${expandedMenus[item.text] ? 'expanded' : ''}`}>
                                                {item.submenu.map((subItem, subIndex) => {
                                                    // Check if this specific subItem should be active
                                                    const isSubItemActive = location.pathname === getLanguagePath(subItem.path) ||
                                                        (location.pathname.startsWith(getLanguagePath(subItem.path) + '/') &&
                                                            !item.submenu.some(otherSubItem =>
                                                                otherSubItem !== subItem &&
                                                                location.pathname === getLanguagePath(otherSubItem.path)
                                                            ));

                                                    return (
                                                        <li key={subIndex} className="submenu-item">
                                                            <Link
                                                                to={getLanguagePath(subItem.path)}
                                                                className={`submenu-link ${isSubItemActive ? 'active' : ''}`}
                                                            >
                                                                {!collapsed ? subItem.text : subItem.text.charAt(0)}
                                                            </Link>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        )}
                                    </>
                                ) : (
                                    <></>
                                    // <Link to={getLanguagePath(item.path)} className="nav-link" onClick={() => logout()}>
                                    // <Link className="nav-link" onClick={() => logout()}>
                                    //   <FontAwesomeIcon icon={item.icon} className="nav-icon" />
                                    //   {!collapsed && <span className="nav-text">{item.text}</span>}
                                    // </Link>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </div>

            <div className="sidebar-footer">
                {!collapsed && (
                    <div className="user-info">
                        {/* <div className="user-name">Admin User</div>
                        <div className="user-role">Administrator</div> */}
                    </div>
                )}
                {/* <Link to={getLanguagePath('/logout')} className="logout-button"> */}
                {/* <Link onClick={() => logout()} className="logout-button">
          <FontAwesomeIcon icon={faSignOutAlt} />
          {!collapsed && <span>Logout</span>}
        </Link> */}
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    leftbar: state.mainReducerData.leftbar,
    userCredentials: state.LoginReducer.userCredentials,
    currentStore: state.StoreReducer.currentStore
});

export default connect(mapStateToProps, { handleLeft, setToken, setUserEntryType, setUserCredentials, logOutApp })(Sidebar);